/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @version 1.1.0
 * @since 1.0.1
 */

import IWidgetSubscriberMobileTranslation from '../../../types/pages/dashboard/widgetSubscriberMobile';

const initTranslationWidgetSubscriberMobile: IWidgetSubscriberMobileTranslation = {
    activeSubs: '',
    blockedSubs: '',
    fail: {
        text: '',
    },
    labels: {
        empty: {
            title: '',
            helpText: '',
            btnText: '',
        },
        label: '',
    },
    noSimCard: '',
    statuses: {
        activeSubs: '',
        blockedSubs: '',
        noSimCard: '',
    },
    successful: {
        labels: '',
        tariff: '',
    },
    tariffs: {
        empty: {
            title: '',
            helpText: '',
            btnText: '',
        },
        label: '',
    },
    title: '',
};

export default initTranslationWidgetSubscriberMobile;
